var $e897441eed0b833f$exports = {};
$e897441eed0b833f$exports = {
    "clear": `Not\u{12B}r\u{12B}t`,
    "invalid": `(neder\u{12B}gs)`,
    "loading": `Notiek iel\u{101}de...`,
    "noResults": `Nav rezult\u{101}tu`,
    "valid": `(der\u{12B}gs)`
};


export {$e897441eed0b833f$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
